module.exports = __webpack_public_path__ + "img/23.e5a3b625.jpg";